import { render } from "./ProfilDetailsNachrichten.pug?vue&type=template&id=68c8bb9b&lang=pug"
import script from "./ProfilDetailsNachrichten.js?vue&type=script&lang=js"
export * from "./ProfilDetailsNachrichten.js?vue&type=script&lang=js"

import exportComponent from "/var/lib/jenkins/workspace/rel_build_mdm/frontend/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__